export const JSON_NAMES = {
  names: [
    "data_tech_podcasts_research-S.json",
    "data_ski_trip_packing-S.json",
    "data_friend_visit-L.json",
    "data_college_research-S.json",
    "data_keto_meal_plan-L.json",
    "data_national_park_day_trip-L.json",
    "data_gaming_laptop-S.json",
    "data_morning_routine_focus-S.json",
    "data_plan_trip_tokyo-S.json",
    "data_fitness_tracker_choice-L.json",
    "data_workout_routine-S.json",
    "data_eco_cleaning_products-L.json",
    "data_job_interview_prep-L.json",
    "data_friend_visit-S.json",
    "data_book_writing_timeline-S.json",
    "data_rome_tourist_attractions-L.json",
    "data_rome_tourist_attractions-S.json",
    "data_standing_desk-S.json",
    "data_plan_trip_tokyo-L.json",
    "data_coffee_shop_opening-S.json",
    "data_job_interview_prep-S.json",
    "data_national_park_day_trip-S.json",
    "data_travel_credit_card-S.json",
    "data_weight_loss_plan-S.json",
    "data_tech_podcasts_research-L.json",
    "data_eco_cleaning_products-S.json",
    "data_book_writing_timeline-L.json",
    "data_house_down_payment_plan-S.json",
    "data_surprise_party_planning-L.json",
    "data_ai_learning-L.json",
    "data_ski_trip_packing-L.json",
    "data_morning_routine_focus-L.json",
    "data_weight_loss_plan-L.json",
    "data_monthly_budget-S.json",
    "data_keto_meal_plan-S.json",
    "data_project_timeline-S.json",
    "data_project_timeline-L.json",
    "data_fitness_tracker_choice-S.json",
    "data_college_research-L.json",
    "data_monthly_budget-L.json",
    "data_surprise_party_planning-S.json",
    "data_spanish_learning-L.json",
    "data_tech_conference_schedule-S.json",
    "data_workout_routine-L.json",
    "data_tech_conference_schedule-L.json",
    "data_kitchen_renovation-S.json",
    "data_coffee_shop_opening-L.json",
    "data_kitchen_renovation-L.json",
    "data_house_down_payment_plan-L.json",
    "data_standing_desk-L.json",
    "data_ai_learning-S.json",
    "data_gaming_laptop-L.json",
    "data_travel_credit_card-L.json",
    "data_spanish_learning-S.json",
  ],
};
